import logo from './logo.svg';
import './App.css';
import style from './App.module.css'
import Landing from './components/Landing/Landing';
import Morals from './components/Morals/Morals';
import Tokenomics from './components/Tokenomics/Tokenomics';
import Whitepaper from './components/Whitepaper/Whitepaper';
import Roadmap from './components/Roadmap/Roadmap';
import Games from './components/Games/Games';

function App() {
  return (
    <div className={`${style.Container} App`}>
      
      <Landing />
      <Morals />
      <Tokenomics />
      <Whitepaper />
      <Roadmap />
      <Games />

    </div>
  );
}

export default App;
